<template>
    <!-- cate -->
    <div class="search-categray">
        <div class="select-list scrollbar">
            <v-treeview
                v-model="selection"
                selectable
                :items="categoryData.folders"
                item-key="name"
                open-on-click
                @input="change_selection"
                v-if="isShow"
            ></v-treeview>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { getSchema } from "@/api/configs.js";
export default {
    name: "search-categray",
    data() {
        return {
            categoryData: "",
            selection: [],
            isShow: false
        };
    },
    watch: {
        resetFilterCondition(newData) {
            this.close_select();
        }
    },
    computed: {
        ...mapState("triggerEvtents", ["resetFilterCondition"])
    },
    created() {
        this.get_category_data();
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        async get_category_data() {
            let { data } = await getSchema("get-options");
            this.categoryData = data;
        },
        change_selection() {
            this.$emit("updateCategory", this.selection);
        },
        open_select() {
            this.isShow = true;
        },
        close_select() {
            this.isShow = false;
            this.selection = [];
        }
    }
};
</script>

<style lang="scss">
.search-categray {
    .select-list {
        padding-top: 16px;
        height: 340px;
        overflow-y: auto;

        .v-treeview-node {
            .v-treeview-node__label {
                font-size: 14px;
            }

            .v-treeview-node__root {
                min-height: 38px;

                .v-icon {
                    flex-shrink: 0;
                }
            }
        }
    }
}

.type-box .categray-box {
    margin-left: 16px;
    .cate {
        padding: 6px 12px;
        background-color: #e0e0e0;
        font-size: 14px;
    }

    .v-menu__content {
        background-color: $color-white;
        width: 350px;

        .v-input {
            width: 100%;
        }

        .accep-btn {
            position: absolute;
            right: 16px;
            bottom: 20px;
        }
    }
}
</style>
